import React from "react";
import { Helmet } from "react-helmet-async";
import { AdBlock } from "../../atoms/AdBlock/AdBlock";
import { Box } from "../../atoms/Layout/Box/Box";
import { Block } from "../../atoms/Layout/Block/Block";
import { GridCell } from "../../atoms/Layout/GridCell/GridCell";
import { GridRow } from "../../atoms/Layout/GridRow/GridRow";
import { DesktopQuery, MobileQuery } from "../../atoms/Layout/Responsive";
import { GameState } from "../../models/Enums";
import { Game } from "../../models/Game";
import { User } from "../../models/User";
import { GameDescription } from "../../molecules/GameDescription/GameDescription";
import { HaveQuestions } from "../../molecules/HaveQuestions/HaveQuestions";
import { Leaderboard } from "../../molecules/Leaderboard/Leaderboard";
import { RecentlyPlayedGames } from "../../molecules/Recomendations/RecentlyPlayed";
import { YouMayAlsoLikeGames } from "../../molecules/Recomendations/YouMayAlsoLike";
import { RightRail } from "../../molecules/RightRail/RightRail";
import { ScoreBox } from "../../molecules/ScoreBox/ScoreBox";
import { GameContainer } from "../../organisms/Game/GameContainer";
import { FriendContainer } from "../../molecules/Friend/FriendContainer";
import { NotificationBanner } from "../../molecules/NotificationBanner/NotificationBanner";
import AARPAdUnitsMeta from "../../services/AARPAdUnitsMeta";
import styles from "./Game.css";
import { AtariBlock } from "../../molecules/AtariBlock/AtariBlock";
import { connect } from "react-redux";
import { gameDetailPageStructuredData } from "../../constants/SchemasSEO";
import { getBadgeByGame } from "../../constants/Badges";
import { setSdkLoaded, TArkadiumSdkStore } from "../../store/reducers";
import { environment } from "../../config/environment";

type GameTemplateProps = {
  games: Game[];
  game: Game;
  user: User;
  url: string;
  gameState: GameState;
  isTheaterMode: boolean;
  dispatch?: any;
};

interface RootState {
  isTheaterMode: boolean;
  sdkLoaded: TArkadiumSdkStore;
}

const ContentCell = (props: any) => (
  <GridCell className={styles.contentCell} {...props} />
);

export const SDK_ENV = {
  stage: "DEV" as const,
  production: "PROD" as const,
};

export const ARENA_ENV = {
  stage: "dev" as const,
  production: "prod" as const,
};

class GameTemplateDumb extends React.PureComponent<GameTemplateProps> {
  handleTheaterModeLayout() {
    const { games, gameState, game, user, isTheaterMode } = this.props;
    const isToHideLeaderboard = !!game.seo_HideLeaderboard;

    if (isTheaterMode) {
      return (
        <>
          <GridRow>
            <GridCell size={[8, 12]}>
              <GridRow>
                <GridCell size={[12, 12]} direction="column">
                  <ScoreBox slug={game.slug} gameState={gameState} />
                </GridCell>
              </GridRow>
              <GridRow>
                <GridCell size={[12, 12]} direction="column">
                  {game.seo_IsFriendGame && (
                    <FriendContainer
                      user={user}
                      game={game}
                      gameState={gameState}
                    />
                  )}
                </GridCell>
              </GridRow>

              <Block paddingB="x3l">
                <GridRow>
                {!isToHideLeaderboard && (
                  <GridCell size={[6, 12]}>
                    <Leaderboard game={game} gameState={gameState} />
                  </GridCell>
                )}
                  <DesktopQuery>
                    <GridCell size={isToHideLeaderboard ? [12, 12] : [6, 12]}>
                      <GameDescription game={game} />
                    </GridCell>
                  </DesktopQuery>
                </GridRow>
              </Block>

              <GridRow>
                <GridCell size={[12, 12]} direction="column">
                  <Block paddingB="x3l">
                    <YouMayAlsoLikeGames
                      games={games}
                      game={game}
                      user={user}
                    />
                  </Block>
                  <RecentlyPlayedGames games={games} user={user} />
                </GridCell>
              </GridRow>

              <GridRow>
                <GridCell size={[12, 12]}>
                  <AtariBlock game={game} />
                  <DesktopQuery>
                    <HaveQuestions game={game} />
                  </DesktopQuery>
                  <MobileQuery>
                    <RightRail mode="Home" topGap={true} />
                    <HaveQuestions game={game} />
                  </MobileQuery>
                </GridCell>
              </GridRow>
            </GridCell>

            <DesktopQuery>
              <GridCell size={[4, 12]} direction="column">
                <RightRail mode="Game" />
              </GridCell>
            </DesktopQuery>
          </GridRow>
        </>
      );
    } else {
      return (
        <>
          <GridRow>
            <GridCell size={[12, 12]} direction="column">
              <ScoreBox slug={game.slug} gameState={gameState} />
            </GridCell>
          </GridRow>
          <GridRow>
            <GridCell size={[12, 12]} direction="column">
              {game.seo_IsFriendGame && (
                <FriendContainer
                  user={user}
                  game={game}
                  gameState={gameState}
                />
              )}
            </GridCell>
          </GridRow>
          <Block paddingB="x3l">
            <GridRow>
              {!isToHideLeaderboard && (
                <GridCell size={[6, 12]}>
                  <Leaderboard game={game} gameState={gameState} />
                </GridCell>
              )}
              <DesktopQuery>
                <GridCell size={isToHideLeaderboard ? [12, 12] : [6, 12]}>
                  <GameDescription game={game} />
                </GridCell>
              </DesktopQuery>
            </GridRow>
          </Block>
          <GridRow>
            <GridCell size={[12, 12]} direction="column">
              <Block paddingB="x3l">
                <YouMayAlsoLikeGames games={games} game={game} user={user} />
              </Block>
              <RecentlyPlayedGames games={games} user={user} />
            </GridCell>
          </GridRow>
          <GridRow>
            <GridCell size={[12, 12]}>
              <AtariBlock game={game} />
              <DesktopQuery>
                <HaveQuestions game={game} />
              </DesktopQuery>
              <MobileQuery>
                <RightRail mode="Home" topGap={true} />
                <HaveQuestions game={game} />
              </MobileQuery>
            </GridCell>
          </GridRow>
        </>
      );
    }
  }

  onSdkLoad = async () => {
    try {
        const env = SDK_ENV[environment.AARP_ENV as keyof typeof SDK_ENV];
        const sdk = await window.__ArenaApi__?.getInstance(env);
        if (sdk) {
          sdk.ads?.setVideoAdsDomain('games.aarp.org');
          this.props.dispatch(setSdkLoaded(sdk));
        }
    } catch (e) {
      console.log('SDK ERROR', e);
      console.error(e);
    }
  };

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://developers.arkadium.com/cdn/sdk/v2/arena-sdk.js";
    script.defer = true;
    script.onload = this.onSdkLoad;
    document.body.appendChild(script);
  }

  render() {
    const { game, user, url, isTheaterMode } = this.props;
    const description = game.seo_MetaHTMLDescription
      ? game.seo_MetaHTMLDescription
      : game.description;
    const title = game.seo_MetaHTMLTitle ? game.seo_MetaHTMLTitle : game.name;
    //! If update this component
    //! Change the pageChangedDate for new current date
    const pageChangedDate = new Date("2022-12-07T10:52:01.670Z").toISOString();
    const schemaData = gameDetailPageStructuredData(
      url,
      title,
      description,
      game,
      pageChangedDate
    );
    const badge = getBadgeByGame(game.slug);

    return (
      <React.Fragment>
        <Helmet
          htmlAttributes={
            game.isSpain() ? { lang: "es", class: "no-js" } : { lang: "en-US" }
          }
          title={game.seo_MetaHTMLTitle || game.name}
          meta={[
            {
              name: "description",
              content: game.seo_MetaHTMLDescription || game.description,
            },
            {
              name: "robots",
              content: "index,follow",
            },
            {
              property: "og:title",
              content: game.seo_OgTitle,
            },
            {
              property: "og:description",
              content: game.seo_OgDescription,
            },
            !!badge && {
              name: "activityId",
              id: "activityId",
              content: badge.ActivityId,
            },
            ...AARPAdUnitsMeta.game(game),
          ]}
          link={[
            { rel: "canonical", href: url },
            { rel: "stylesheet", href: "https://use.typekit.net/bjs6uer.css" },
          ]}
        >
          {game.seo_IsSchemaEnable && (
            <>
              <script type="application/ld+json">
                {JSON.stringify(schemaData)}
              </script>
            </>
          )}
        </Helmet>
        <NotificationBanner game={game} />
        <GridRow>
          <ContentCell
            size={isTheaterMode ? [12, 12] : [8, 12]}
            direction="column"
          >
            <Block paddingB="xl">
              <GameContainer user={user} game={game} isDisplayAdsEnabled />
            </Block>

            <MobileQuery>
              <Box align="center" justify="center" paddingB="xl">
                <AdBlock id="adslot1010" size="300x250" />
              </Box>
              <Block paddingB="xl">
                <GameDescription game={game} />
              </Block>
            </MobileQuery>

            {this.handleTheaterModeLayout()}
          </ContentCell>

          <DesktopQuery>
            {!isTheaterMode && (
              <GridCell size={[4, 12]} direction="column">
                <RightRail mode="Game" />
              </GridCell>
            )}
          </DesktopQuery>
        </GridRow>
      </React.Fragment>
    );
  }
}

export const GameTemplate = connect((state: RootState) => ({
  isTheaterMode: state.isTheaterMode,
  sdkLoaded: state.sdkLoaded,
}))(GameTemplateDumb);
